import styled from "styled-components";
import { useTranslation } from "react-i18next";

import {
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_SECONDARY_TEXT_COLOR,
    VOTEBOX_SUCCESS_COLOR,
} from "./voteboxTokens";
import { VoteStatus } from "../Deliberation/useVoteState";
import { getRemainingWeight } from "./services/getRemainingWeight";

type Answer = {
    id: string;
    weight: number;
    disableOtherPropositionsIfSelected: boolean;
};

type Props = {
    participant: { displayName: string; weight: number };
    voteIsWithDistribution: boolean;
    participantVote: {
        voteStatus: string;
        answers: Array<Answer>;
    };
    isGroupedDeliberation?: boolean;
};

const ParticipantHeader = ({
    participant,
    voteIsWithDistribution,
    participantVote,
    isGroupedDeliberation,
}: Props) => {
    const { t } = useTranslation();

    const hasSeveralVotes = participant.weight > 1;
    const hasVoted = VoteStatus.Success === participantVote.voteStatus;
    // With several votes, only a distribution outside a grouped deliberation says it is sent.
    const canShowSuccessMessage =
        !hasSeveralVotes || (voteIsWithDistribution && !isGroupedDeliberation);
    // With a distribution, the votes left come first: "Nombre de voix 2/5".
    const remainingWeightPrefix = voteIsWithDistribution
        ? `${getRemainingWeight(participant.weight, participantVote.answers)}/`
        : null;
    const numberOfVoices = hasSeveralVotes ? (
        <StyledNumberOfVoices>
            {t("numberOfVote")}
            {remainingWeightPrefix}
            {participant.weight}
        </StyledNumberOfVoices>
    ) : null;
    const successMessage =
        canShowSuccessMessage && hasVoted ? (
            <StyledSuccessVotedMessage>
                {t(`sentSucceded.${window.env.REACT_APP_THEME}`)}
            </StyledSuccessVotedMessage>
        ) : null;

    return (
        <>
            {numberOfVoices}
            {successMessage}
        </>
    );
};

const StyledNumberOfVoices = styled.div`
    color: ${VOTEBOX_SECONDARY_TEXT_COLOR};
    padding-bottom: 0.5rem;
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
`;

const StyledSuccessVotedMessage = styled.p`
    color: ${VOTEBOX_SUCCESS_COLOR};
    margin: 0;
    font-size: 0.85rem;
`;

export default ParticipantHeader;
